import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('no-next-steps-section', []);

module.component('noNextStepsSection', {
    template: template,
    controller: function() {}
});

export { module };
